import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";

const YaraConfirmModal = ({
  isEditMode,
  show,
  onHide,
  rulesetName,
  onClickNo = () => {},
  onClickYes = () => {},
  onClickCancel = () => {}
}) => (
  <Modal show={show} onHide={onHide} size="sm">
    <Modal.Header closeButton>
      <Modal.Title>Confirm</Modal.Title>
    </Modal.Header>

    <Modal.Body>
      <p>This ruleset is not saved!</p>
      <br />
      <p>
        Do you wish to
        {isEditMode
          ? " save changes for ruleset "
          : " create a new ruleset named "}
        <strong>{rulesetName}</strong>
      </p>
    </Modal.Body>

    <Modal.Footer>
      <Button onClick={() => onClickYes()} variant="primary">
        Yes
      </Button>
      <Button onClick={() => onClickNo()} variant="primary">
        No
      </Button>
      <Button onClick={() => onClickCancel()} variant="primary">
        Cancel
      </Button>
    </Modal.Footer>
  </Modal>
);

YaraConfirmModal.propTypes = {
  isEditMode: PropTypes.bool,
  show: PropTypes.bool,
  rulesetName: PropTypes.string,
  onHide: PropTypes.func,
  onClickNo: PropTypes.func,
  onClickYes: PropTypes.func,
  onClickCancel: PropTypes.func
};

export default YaraConfirmModal;
